import FormOverlay from "../../../../components/Modal";
import React from "react";
import FieldGroup from "../../../../components/FieldGroup";

export default class PartnerDomainsForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            domain: {}
        }

        this.handleFieldChange = this.handleFieldChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            domain: this.props.domain
        })
    }

    handleFieldChange({ target }) {
        this.setState({ domain: { ...this.state.domain, [target.name]: target.value } })
    }

    async handleSubmit(e) {
        e.preventDefault();

        this.props.onNoteSave(this.state.domain.id, this.state.domain.note)
    }

    render () {
        return (
            <FormOverlay onHide={this.props.onHide}>
                <div className={"d-flex justify-content-center"}>
                    <form style={{ margin: '0.5em', width: '100%' }}>
                        <FieldGroup
                            name="note"
                            onChange={this.handleFieldChange}
                            value={this.state.domain.note || ""}
                            maxLength={64}
                            required
                            label="Note"
                        />

                        <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={this.handleSubmit.bind(this)}
                            style={{ marginBottom: '1em' }}
                        >
                            Save
                        </button>
                    </form>

                </div>
            </FormOverlay>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scenes/PartnerDomains/components/PartnerDomainsForm/PartnerDomainsForm.js